import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./custom-datepicker.css";
import Icons from "../../assets/icon/index";
import AppStoreIcon from "../../assets/image/App_Store_2x.png";
import GooglePlayIcon from "../../assets/image/Google_Play_2x.png";
import {
  Navbar,
  Footer,
  MainHeading,
  HoverButton,
  FormInput,
  DefaultValueCountry,
  PrefilledDropDown,
  Textarea,
  Animatespin,
  InfoTooltip,
} from "../../components";
import Functions from "./index.function";

const GEMAuditionForm = () => {
  const {
    register,
    navigate,
    handleSubmit,
    setValue,
    control,
    errors,
    onSubmit,
    loadingToapi,
    setCountryCode,
    setCca2,
    userprofile,
    isLoggedIn,
    isLoadingAuditionStatus,
    hasSubmission,
    isEnrollMode,
    dropdowns,
    isDropdownLoading,
    isError,
    error,
    states,
    isLoadingStates,
    cities,
    isLoadingCities,
    proofOfPayment,
    video,
    proofOfPaymentPreview,
    videoPreview,
  } = Functions();

  // While checking status, and in the brief moment before redirecting an
  // already-submitted user to /gem-audition-status, show a loader instead
  // of flashing the form.
  if (isLoggedIn && (isLoadingAuditionStatus || hasSubmission)) {
    return (
      <div className="bg-primary">
        <Navbar />
        <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-10">
          <Animatespin />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="bg-primary">
      <Navbar />
      <div className="lg:px-5 xl:px-10 sm:px-5 xs:px-3 m-auto xs:py-5">
        <div className="flex flex-col items-center xs:mt-3 sm:mt-3 lg:mt-6">
          <h4 className="font-unboundedBold text-secondary xs:text-base sm:text-base xl:text-2xl capitalize">
            Download the App
          </h4>
          <div className="flex items-center gap-7 xs:mt-4 sm:mt-4 lg:mt-6">
            <a
              href="https://apps.apple.com/us/app/gem-global/id6755765029"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 transform hover:scale-105 shadow"
            >
              <img
                src={AppStoreIcon}
                alt="Download on App Store"
                className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.geminc.gem"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 transform hover:scale-105 shadow"
            >
              <img
                src={GooglePlayIcon}
                alt="Get it on Google Play"
                className="xs:h-9 sm:h-9 lg:h-10 xl:h-12 w-auto"
              />
            </a>
          </div>
        </div>
        <MainHeading
          title={"GEM Audition Form"}
          dis={"Tell us about yourself to complete your audition submission."}
          disStyle={{ fontSize: 25,  marginTop: 25 }}
          layout={"h-18 sm:h-20 lg:h-36"}
        />
        
        <div className="max-w-5xl m-auto xs:pt-3 sm:pt-4 lg:py-5">
          <form
            className="flex justify-center items-center flex-col"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
          >
            {/* Name */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center">
              <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  userData={userprofile}
                  isdisabled={isEnrollMode}
                  label="First Name"
                  type="text"
                  name="first_name"
                  placeholder="Enter First Name"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                  pattern={{
                    value: /^[A-Za-z\s]+$/,
                    message: "First Name can only contain letters",
                  }}
                />
              </div>
              <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  userData={userprofile}
                  isdisabled={isEnrollMode}
                  label="Last Name"
                  type="text"
                  name="last_name"
                  placeholder="Enter Last Name"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                  pattern={{
                    value: /^[A-Za-z\s]+$/,
                    message: "Last Name can only contain letters",
                  }}
                />
              </div>
            </div>

            {/* DOB + Gender */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center">
              <Controller
                control={control}
                name="date_of_birth"
                rules={{ required: "Date of Birth is required" }}
                render={({ field }) => (
                  <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                    <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary">
                      Date of Birth <span className="text-errorRed">*</span>
                    </p>
                    <DatePicker
                      placeholderText="Select your date of birth"
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date) => field.onChange(date)}
                      maxDate={new Date()}
                      dateFormat="dd-MM-yyyy"
                      className="xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    {errors.date_of_birth && (
                      <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                        {errors.date_of_birth.message}
                      </span>
                    )}
                  </div>
                )}
              />

              <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary">
                  Select Gender <span className="text-errorRed">*</span>
                </p>
                <select
                  {...register("gender_id", {
                    required: "Gender is required",
                  })}
                  className="appearance-none xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic pr-12"
                  disabled={isDropdownLoading}
                >
                  <option value="">Select Gender</option>
                  {dropdowns?.gender?.length > 0 ? (
                    dropdowns.gender.map((g) => (
                      <option key={g.id} value={g.gender_id}>
                        {g.gender}
                      </option>
                    ))
                  ) : (
                    <option disabled>Loading...</option>
                  )}
                </select>
                {isError && (
                  <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                    Error loading gender list: {error?.message}
                  </span>
                )}
                {errors.gender_id && (
                  <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                    {errors.gender_id.message}
                  </span>
                )}
              </div>
            </div>

            {/* Hide DOB */}
            {/* <div className="flex justify-start items-center mt-[18px] xs:w-full sm:w-full lg:w-full">
              <label className="custom-radio cursor-pointer w-9 flex justify-center items-center">
                <input
                  type="checkbox"
                  className="hidden peer"
                  disabled={isEnrollMode}
                  {...register("hide_dob_from_front_end")}
                />
                <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
              </label>
              <p className="ml-3 text-[16px] text-[#808080]">
                Hide my date of birth from my public profile
              </p>
            </div> */}

            {/* Email + Phone */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center">
              <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                <FormInput
                  label="Email Address"
                  control={control}
                  userData={userprofile}
                  isdisabled={isEnrollMode}
                  name="email"
                  type="email"
                  placeholder="Enter Email Address"
                  isMandatory={true}
                  isRequired={true}
                  pattern={{
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  }}
                  errors={errors}
                />
              </div>
              <div className="relative mt-[18px] xs:w-full sm:w-1/2">
                <DefaultValueCountry
                  label="Phone Number"
                  type="text"
                  name="mobile_num"
                  placeholder="Enter Mobile Number"
                  defaultValue={userprofile?.mobile_num}
                  countryCode={userprofile?.country_code}
                  cca2={userprofile?.cca2}
                  control={control}
                  register={register}
                  isMandatory={true}
                  disabled={isEnrollMode}
                  onChange={(value) => setValue("mobile_num", value)}
                  errors={errors}
                  setCountryCode={setCountryCode}
                  setCca2={setCca2}
                />
              </div>
            </div>

            {/* Password - only relevant for a brand-new (guest) registration */}
            {!isLoggedIn && (
              <div className="w-full mt-[18px]">
                <FormInput
                  control={control}
                  label="Password"
                  type="password"
                  name="password"
                  placeholder="Password"
                  isPassword={true}
                  isMandatory={true}
                  isRequired={true}
                  iconPasswordVisible={Icons.showPasswordIcon}
                  iconPasswordHidden={Icons.hidePasswordIcon}
                  iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7"}
                  pattern={{
                    value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                    message:
                      "Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
                  }}
                  errors={errors}
                />
              </div>
            )}

            {/* Location */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <PrefilledDropDown
                  options={dropdowns?.country || []}
                  control={control}
                  name="country_id"
                  label="Country"
                  rightIcon={Icons.arrowIcon}
                  isMandatory={true}
                  valueoption="country_id"
                  valueName="country"
                  errors={errors}
                  isLoading={isDropdownLoading}
                />
              </div>
              <div className="relative xs:w-full sm:w-1/2">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  rightIcon={Icons.arrowIcon}
                  label={"Province / State"}
                  options={states || []}
                  valueName="state"
                  isMandatory={true}
                  valueoption="id"
                  name={"state_id"}
                  isLoading={isLoadingStates}
                />
              </div>
            </div>
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <PrefilledDropDown
                  control={control}
                  errors={errors}
                  rightIcon={Icons.arrowIcon}
                  label={"City"}
                  options={cities || []}
                  valueName="city"
                  isMandatory={true}
                  valueoption="id"
                  name={"city_id"}
                  isLoading={isLoadingCities}
                />
              </div>
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Event Code"
                  type="text"
                  name="event_code"
                  placeholder="Enter event code"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />   
              </div>
            </div>
            {/* Education & Experience */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Qualification"
                  type="text"
                  name="qualification"
                  placeholder="Enter qualification"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />   
                <div className="mt-3 text-sm font-onestRegular text-secondary leading-6" style={{paddingLeft: 30, borderWidth: 1, borderRadius: 12}}>
                  <p>Bank: United Bank Limited (UBL)</p>
                  <p>Account Title: Global Entertainment Movement Pakistan</p>
                  <p>Account Number: 335209312</p> 
                  <p>Iban: PK81UNIL0109000335209312</p>
                  <p>Branch Code: 0109</p>
                </div>
              </div>
              <div className="relative xs:w-full sm:w-1/2"> 
                <Textarea
                  lable={"Acting / Performance Experience"}
                  name={"experience"}
                  register={register}
                  setValue={setValue}
                  errors={errors}
                  isMandatory={true}
                />
              </div>
            </div>
            {/* Proof of Payment */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
              <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center gap-1.5 text-secondary relative">
                Proof of Payment <span className="text-errorRed">*</span>
                <InfoTooltip
                  label="Proof of payment"
                  content={
                    <>
                      <p className="font-onestMedium text-[13px] mb-1">
                        Payment Proof
                      </p>
                      <p className="mb-2">
                        Registration Fee: <strong>PKR 1,000</strong>
                      </p>
                      <p className="mb-2">
                        Please transfer the registration fee using the
                        following account:
                      </p>
                      <ul className="space-y-0.5 mb-2">
                        <li>
                          <strong>Bank Name:</strong> United Bank Limited
                          (UBL)
                        </li>
                        <li>
                          <strong>Account Title:</strong> Global
                          Entertainment Movement Pakistan
                        </li>
                        <li>
                          <strong>Account Number:</strong> 335209312
                        </li>
                        <li>
                          <strong>IBAN:</strong> PK81UNIL0109000335209312
                        </li>
                        <li>
                          <strong>Branch Code:</strong> 0109
                        </li>
                      </ul>
                      <p>
                        After completing the payment, take a clear screenshot
                        of the successful transaction. You will be required
                        to upload this screenshot with your audition
                        application.
                      </p>
                    </>
                  }
                />
              </p>
              <label
                htmlFor="proof_of_payment"
                className="flex justify-center items-center xs:px-6 sm:px-6 lg:px-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-3xl cursor-pointer text-[#808080] border-dashed border-2 border-transparent hover:border-goldMetallic transition duration-300"
              >
                {proofOfPayment?.[0]?.name || "Click to upload image (proof of payment)"}
              </label>
              <input
                id="proof_of_payment"
                type="file"
                accept="image/*"
                className="hidden"
                {...register("proof_of_payment", {
                  validate: (value) =>
                    (value && value.length > 0) ||
                    "Proof of payment is required",
                })}
              />
              {errors.proof_of_payment && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.proof_of_payment.message}
                </span>
              )}
              {proofOfPaymentPreview && (
                <div className="mt-3">
                  <img
                    src={proofOfPaymentPreview}
                    alt="Proof of payment preview"
                    className="max-h-56 w-auto rounded-2xl border border-[#171717] object-contain"
                  />
                </div>
              )}
            </div>

            {/* Video */}
            <div className="relative xs:w-full sm:w-1/2">
              <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center gap-1.5 text-secondary relative">
                Audition Video <span className="text-errorRed">*</span>
                <InfoTooltip
                  label="Audition Video Guidelines"
                  content={
                    <>
                      <p className="font-onestMedium text-[13px] mb-1">
                        Audition Video Guidelines
                      </p>
                      <p className="mb-2">
                        Video Duration: <strong>2 Minutes</strong>
                      </p>
                      <p className="mb-2">
                        <strong>1. Introduce Yourself (30 Seconds)</strong>
                      </p>
                      <p className="mb-2">Start with a brief introduction:</p>
                      <ul className="space-y-0.5 mb-2">
                        <li>
                          <strong>Your Name</strong> 
                        </li>
                        <li>
                          <strong>Age</strong>
                        </li>
                        <li>
                          <strong>City</strong> 
                        </li>
                        <li>
                          <strong>A little about yourself</strong>
                        </li> 
                      </ul>
                      <p className="mb-2">
                        <strong>2. Show Your Acting Skills (1 Minute 30 Seconds)</strong>
                      </p>
                      <p className="mb-2">Perform a dialogue or short scene of your choice. Show your acting skills through expressions, emotions, confidence, and dialogue delivery.</p>
                      <p className="mb-2">
                        <strong>Before Recording:</strong>
                      </p>
                      <ul className="space-y-0.5 mb-2">
                        <li>
                          <strong>Choose a quiet, well-lit place.</strong> 
                        </li>
                        <li>
                          <strong>Keep your face clearly visible and voice clear.</strong>
                        </li>
                        <li>
                          <strong>Avoid background music, filters, or heavy editing.</strong> 
                        </li> 
                      </ul>
                      <p className="mb-2">
                        <strong>Give your best performance and let your talent shine!</strong>
                      </p>
                    </>
                  }
                />
              </p>
              <label
                htmlFor="video"
                className="flex justify-center items-center xs:px-6 sm:px-6 lg:px-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-3xl cursor-pointer text-[#808080] border-dashed border-2 border-transparent hover:border-goldMetallic transition duration-300"
              >
                {video?.[0]?.name || "Click to upload your audition video"}
              </label>
              <input
                id="video"
                type="file"
                accept="video/*"
                className="hidden"
                {...register("video", {
                  validate: (value) =>
                    (value && value.length > 0) ||
                    "Audition video is required",
                })}
              />
              {errors.video && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.video.message}
                </span>
              )}
              {videoPreview && (
                <div className="mt-3">
                  <video
                    src={videoPreview}
                    controls
                    className="max-h-56 w-full rounded-2xl border border-[#171717]"
                  />
                </div>
              )}
              </div>  
            </div>
            {/* Physical Appearance */}
            <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Hair Color"
                  type="text"
                  name="hair_color"
                  placeholder="Enter hair color"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />   
                 
              </div>
              <div className="relative xs:w-full sm:w-1/2"> 
                <FormInput
                  control={control}
                  errors={errors}
                  label="Eye Color"
                  type="text"
                  name="eye_color"
                  placeholder="Enter eye color"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />  
              </div>
            </div>
             <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Skin Tone"
                  type="text"
                  name="skin_tone"
                  placeholder="Enter skin tone"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />   
                 
              </div>
              <div className="relative xs:w-full sm:w-1/2"> 
                <FormInput
                  control={control}
                  errors={errors}
                  label="Body Type"
                  type="text"
                  name="body_type"
                  placeholder="Enter body type"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />  
              </div>
            </div>
             <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Height"
                  type="text"
                  name="height"
                  placeholder="Enter height in CM"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />   
                 
              </div>
              <div className="relative xs:w-full sm:w-1/2"> 
                <FormInput
                  control={control}
                  errors={errors}
                  label="Weight"
                  type="text"
                  name="weight"
                  placeholder="Enter weight in KG"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />  
              </div>
            </div>
            
            {/* Referral / Event Code */}
            {/* <div className="w-full sm:gap-2 lg:gap-4 flex xs:flex-col sm:flex-wrap lg:flex-nowrap items-center mt-[18px]">
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  label="Event Code"
                  type="text"
                  name="event_code"
                  placeholder="Enter event code"
                  maxLength={30}
                  isMandatory={true}
                  isRequired={true}
                />                
              </div>
              <div className="relative xs:w-full sm:w-1/2">
                <FormInput
                  control={control}
                  errors={errors}
                  userData={userprofile}
                  isdisabled={isEnrollMode}
                  label="Referral Code"
                  type="text"
                  name="referral_code"
                  placeholder="Enter referral code"
                  maxLength={30}
                  // isMandatory={true}
                  // isRequired={true}
                />
              </div>
            </div> */}

            {/* Terms of Use */}
            <div
            className={
              "flex flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="flex justify-start items-center mt-5">
              <label className="custom-radio cursor-pointer w-9 flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway">
                <input
                  type="radio"
                  {...register("termsAndConditions", {
                    required: "You must agree to the terms and conditions",
                  })}
                  className="hidden peer"
                />
                <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
              </label>
              <p className="ml-3 xs:text-[16px] sm:text-[16px] md:text-[17px] text-[18px] 3xl:text-[20px] text-[#808080] ">
                I agree to the{" "}
                <span
                  className="underline text-[#808080] hover:text-goldMetallic cursor-pointer transition duration-300 ease-in-out"
                  onClick={() => navigate("/audition-terms-and-conditions")}
                >
                  Terms & Conditions
                </span>{" "}
                of the Global Entertainment Movement
              </p>
            </div>
            <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px]">
              {errors.termsAndConditions && (
                <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                  {errors.termsAndConditions.message}
                </span>
              )}
            </div>
          </div>
            {/* <div className="flex flex-col w-full">
              <div className="flex justify-start items-center mt-5">
                <label className="custom-radio cursor-pointer w-9 flex justify-center items-center">
                  <input
                    type="checkbox"
                    className="hidden peer"
                    disabled={isEnrollMode}
                    {...register(
                      "terms_of_use",
                      isEnrollMode
                        ? {}
                        : { required: "You must agree to the terms of use" }
                    )}
                  />
                  <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
                </label>
                <p className="ml-3 text-[16px] text-[#808080]">
                  I agree to the Terms of Use of the Global Entertainment
                  Movement
                </p>
              </div>
              {errors.terms_of_use && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.terms_of_use.message}
                </span>
              )}
            </div> */}

            {/* Vote To Win */}
            {/* <div className="flex flex-col w-full">
              <div className="flex justify-start items-center mt-5">
                <label className="custom-radio cursor-pointer w-9 flex justify-center items-center">
                  <input
                    type="checkbox"
                    className="hidden peer"
                    disabled={isEnrollMode}
                    {...register("agree_to_vote_to_win")}
                  />
                  <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
                </label>
                <p className="ml-3 text-[16px] text-[#808080]">
                  I agree to be part of the Vote to Win Program for exciting
                  prizes through a lucky draw
                </p>
              </div>
              {errors.agree_to_vote_to_win && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  {errors.agree_to_vote_to_win.message}
                </span>
              )}
            </div> */}

            <div className="flex justify-center w-full items-center my-10 lg:my-8">
              <HoverButton
                extraClasses={`group xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform ${
                  loadingToapi
                    ? ""
                    : "cursor-pointer hover:scale-105 hover:shadow-md"
                }`}
                BtnTitle={
                  loadingToapi ? (
                    <div className="flex justify-center items-center">
                      <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-8 w-8"></div>
                    </div>
                  ) : (
                    "Submit"
                  )
                }
                disabled={loadingToapi}
                type={"submit"}
                BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                  loadingToapi
                    ? ""
                    : "group-hover:scale-110 group-hover:text-primary"
                }`}
              />
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GEMAuditionForm;
